import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/course-edit-attachments-action-types';

import type {Map} from 'immutable';

export type CourseEditAttachmentsStore = {
    course: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        course: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.GET_COURSE_SUCCESS]: (state, action) => {
        return {
            course: action.data,
        };
    },

    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseEditAttachmentsStore>(initialState(), actionsMap);
